import React from 'react';
import PropTypes from 'prop-types';

import {
  alignFlyoutStyle,
  dropdownMenuButtonStyle,
} from 'components/DropdownMenu/styles';
import Box from '../../shared/Box/index.tsx';
import { OutsideClickContainer } from '../OutsideClickContainer/index.tsx';
import { FlyoutMenu } from '../FlyoutMenu';

// having some weird race conditions on iOS when toggling
// the menu open and closed. It will basically quickly open
// the menu, then close it right away. Adding a slight delay
// fixes this. It's quick enough so the user won't notice the delay
const delayFunctionCall = func => setTimeout(() => func, 200);

const DropdownMenu = ({
  shouldShowDistributionItem,
  isMenuVisible,
  renderPressableContent,
  menuItems,
  renderMenuHeader,
  renderMenuFooter,
  flyoutBorderRadius,
  flyoutMarginTop,
  flyoutPaddingTopBottom,
  flyoutWidth,
  alignFlyout,
  onHideMenu,
  onShowMenu,
  onClickMenuFooter,
  buttonStyles,
}) => (
  <Box
    display="flex"
    alignItems="center"
    dangerouslySetInlineStyle={{ flex: 1 }}
  >
    <button
      onClick={() => {
        delayFunctionCall(isMenuVisible ? onHideMenu() : onShowMenu());
      }}
      className={` ${buttonStyles || dropdownMenuButtonStyle}`}
    >
      {renderPressableContent}
    </button>
    {isMenuVisible && (
      <OutsideClickContainer
        onClickOutside={() => {
          delayFunctionCall(onHideMenu());
        }}
        className={alignFlyoutStyle(alignFlyout)}
      >
        <FlyoutMenu
          shouldShowDistributionItem={shouldShowDistributionItem}
          borderRadius={flyoutBorderRadius}
          marginTop={flyoutMarginTop}
          paddingTopBottom={flyoutPaddingTopBottom}
          width={flyoutWidth}
          renderHeader={renderMenuHeader}
          renderFooter={renderMenuFooter}
          onClickFooter={onClickMenuFooter}
          menuItems={menuItems}
          onClickMenuItem={onHideMenu}
        />
      </OutsideClickContainer>
    )}
  </Box>
);

DropdownMenu.defaultProps = {
  shouldShowDistributionItem: false,
  renderMenuHeader: null,
  renderMenuFooter: null,
  flyoutWidth: null,
  alignFlyout: 'top',
  onClickMenuFooter: () => {},
};

DropdownMenu.propTypes = {
  shouldShowDistributionItem: PropTypes.bool,
  isMenuVisible: PropTypes.bool.isRequired,
  renderPressableContent: PropTypes.element.isRequired,
  renderMenuHeader: PropTypes.element,
  renderMenuFooter: PropTypes.element,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['item', 'separator', 'link']),
      label: PropTypes.string,
      description: PropTypes.string,
      iconType: PropTypes.string,
      href: PropTypes.string,
      to: PropTypes.string,
      onClick: PropTypes.func,
      icon: PropTypes.shape({
        backgroundColor: PropTypes.string,
        iconColor: PropTypes.string,
        padding: PropTypes.number,
        type: PropTypes.string,
        width: PropTypes.number,
      }),
      target: PropTypes.string,
      isDownloadLink: PropTypes.bool,
    })
  ).isRequired,
  flyoutBorderRadius: PropTypes.number,
  flyoutMarginTop: PropTypes.number,
  flyoutPaddingTopBottom: PropTypes.number,
  flyoutWidth: PropTypes.number,
  alignFlyout: PropTypes.oneOf(['top', 'bottom']),
  onHideMenu: PropTypes.func.isRequired,
  onShowMenu: PropTypes.func.isRequired,
  onClickMenuFooter: PropTypes.func,
};

export { DropdownMenu };
